export const POS_DRAFTS_SET = "POS_DRAFTS_SET";
